import { Module } from 'wrapper6'

const $ = jQuery

export default class TasksMenu extends Module {
  ready (app) {
    const wrappers = [document.querySelector('.single-student-tasks'), document.querySelector('.single-teacher-tasks')]

    for (let i = 0; i < wrappers.length; i++) {
      const wrapper = wrappers[i]

      if (wrapper) {
        new AddMenu(wrapper).init()
      }
    }
  }
}

class AddMenu {
  constructor (wrapper) {
    this.wrapper = wrapper
    this.widgets = this.wrapper.querySelectorAll('.mtt-tasks-content')

    if (this.widgets.length) {
      this.firstWidget = this.widgets[0]
      this.lastWidget = this.widgets[this.widgets.length - 1]

      this.init = () => {
        this.createMenu()
      }
    }
  }

  createMenu () {
    this.menu = document.createElement('div')
    this.menu.classList.add('menu-wrapper')
    this.wrapper.appendChild(this.menu)

    this.createMenuList()
    this.addSticky()
    this.addSmoothScroll()
  }

  createMenuList () {
    for (let i = 0; i < this.widgets.length; i++) {
      const widget = this.widgets[i]

      if (widget.querySelector('h2')) {
        const h2s = widget.querySelectorAll('h2')
        const h3s = widget.querySelectorAll('h3')

        for (let j = 0; j < h2s.length; j++) {
          const h2 = h2s[j]
          this.addTitleID(h2, i, j, '')
          const link = this.createLink(h2, 'title', i, j, '')

          this.menu.appendChild(link)

          if (h3s && h2s.length <= 1) {
            for (let k = 0; k < h3s.length; k++) {
              const h3 = h3s[k]
              this.addTitleID(h3, i, j, k)
              const link = this.createLink(h3, 'subtitle', i, j, k)

              this.menu.appendChild(link)
            }
          }
        }
      }
    }
  }

  addSticky () {
    const widgetPaddingTop = 40
    this.headerHeight = 80
    this.firstPosTop = this.firstWidget.offsetTop + widgetPaddingTop
    this.logoPosLeft = document.querySelector('#main_header .logo').getBoundingClientRect().left

    this.togglePosition()
    this.toggleMenuHide()
    this.updateMenuLeftPosition()

    window.addEventListener('resize', () => {
      this.updateMenuTopPosition()
      this.updateMenuLeftPosition()
    })

    window.addEventListener('scroll', () => {
      this.togglePosition()
      this.toggleMenuHide()
    })
  }

  togglePosition () {
    if (this.firstWidget.getBoundingClientRect().top <= this.headerHeight) {
      this.menu.style.position = 'fixed'
      this.menu.style.top = '100px'
    } else {
      this.menu.style.position = 'absolute'
      this.menu.style.top = this.firstPosTop + 'px'
    }
  }

  toggleMenuHide () {
    if ((this.lastWidget.getBoundingClientRect().bottom - this.headerHeight) - (this.menu.offsetHeight + 20) <= 0) {
      this.menu.classList.add('hide')
    } else {
      this.menu.classList.remove('hide')
    }
  }

  addSmoothScroll () {
    $(document).on('click', '.menu-wrapper a', (event) => {
      event.preventDefault()

      $('html, body').animate({
        scrollTop: $($.attr(event.currentTarget, 'href')).offset().top - this.headerHeight
      }, 500)
    })
  }

  updateMenuTopPosition () {
    if (this.firstPosTop !== this.firstWidget.offsetTop + 40) {
      this.menu.style.top = (this.firstWidget.offsetTop + 40) + 'px'
    }
  }

  updateMenuLeftPosition () {
    this.menu.style.left = document.querySelector('#main_header .logo').getBoundingClientRect().left + 'px'
  }

  addTitleID (title, key, key2, key3) {
    const idName = 'title-' + title.innerText.replace(/\W/g, '') + key + key2 + key3
    title.setAttribute('id', idName)
  }

  createLink (title, className, key, key2, key3) {
    const idName = '#title-' + title.innerText.replace(/\W/g, '') + key + key2 + key3
    const link = document.createElement('a')
    link.href = idName
    link.innerHTML = title.innerText

    if (className) {
      link.classList.add(className)
    }

    return link
  }
}
